<script>
export default {
  props: {
    businessModelOptions: {
      type: Array,
      default: () => []
    },
    marketSegmentOptions: {
      type: Array,
      default: () => []
    },
    geographicReachOptions: {
      type: Array,
      default: () => []
    },
    countryOptions: {
      type: Array,
      default: () => []
    },
    selectedBusinessModels: {
      type: Array,
      default: () => []
    },
    selectedMarketSegments: {
      type: Array,
      default: () => []
    },
    selectedRevenueSources: {
      type: Array,
      default: () => []
    },
    selectedPredominantMarketSegment: {
      type: String,
      default: ''
    },
    selectedGeographicReaches: {
      type: Array,
      default: () => []
    },
    selectedGeographicReach: {
      type: String,
      default: ''
    },
    selectedInternationalRevenuePercentage: {
      type: [Number, String],
      default: ''
    },
    selectedInternationalClientsCount: {
      type: [Number, String],
      default: ''
    },
    selectedOperatingCountries: {
      type: Array,
      default: () => []
    }
  },

 data() {
    return {
      openDropdown: null,
      openModalDropdown: null, 
      tooltipInstances: [],
      selectedGeographicReachItems: this.normalizeSelectedGeographicReachItems(
        this.selectedGeographicReaches.length ? this.selectedGeographicReaches : (this.selectedGeographicReach ? [{ value: this.selectedGeographicReach }] : [])
      ),
      company: {
        business_models: this.normalizeSelectedItems(this.selectedBusinessModels),
        market_segments: this.normalizeSelectedItems(this.selectedMarketSegments),
        market_segments_percentage: this.normalizeSelectedItems(this.selectedMarketSegments),
        revenue_sources_percentage: this.normalizeRevenueSources(this.selectedRevenueSources),
        predominant_market_segment: this.selectedPredominantMarketSegment,
        geographic_reach: this.selectedGeographicReach,
        international_revenue_percentage: this.selectedInternationalRevenuePercentage,
        international_clients_count: this.selectedInternationalClientsCount,
        operating_countries: this.selectedOperatingCountries
      },
      
     
      removedBusinessModels: [],
      removedGeographicReaches: [],
      removedMarketSegments: [],
      removedOperatingCountries: [],
      maxMarketSegments: 5,
      validationErrors: {},
      iaTypeOptions: [
        { value: 'preditiva', text: 'Preditiva' },
        { value: 'generativa', text: 'Generativa' },
        { value: 'visao', text: 'Visão' },
        { value: 'nlp', text: 'NLP' },
        { value: 'recomendacao', text: 'Recomendação' }
      ],
      iaModelOptions: [
        { value: 'proprio', text: 'Modelo próprio' },
        { value: 'terceiros', text: 'Modelo de terceiros' }
      ],
      iaProviderOptions: [
        { value: 'openai', text: 'OpenAI' },
        { value: 'anthropic', text: 'Anthropic' },
        { value: 'google', text: 'Google' },
        { value: 'outros', text: 'Outros' }
      ],
      iaInvestmentOptions: [
        { value: 'nao_necessita', text: 'Não necessito de investimento' },
        { value: 'ate_100k', text: 'Até R$100 mil' },
        { value: '100k_500k', text: 'De R$100 mil a R$500 mil' },
        { value: '500k_1m', text: 'De R$500 mil a R$1 milhão' },
        { value: '1m_2m', text: 'De R$1 milhão a R$2 milhão' },
        { value: 'mais_2m', text: 'Mais de R$2 milhões' }
      ],
      iaInfraOptions: [
        { value: 'internas', text: 'Internas (temos nossos próprios recursos computacionais)' },
        { value: 'externo', text: 'Externo (contratamos de fornecedores)' },
        { value: 'nao_utilizamos', text: 'Não utilizamos' }
      ],
      newProduct: {
        name: '', description: '', trl: '', uses_ia: null, ia_problem: '',
        ia_types: [],
        ia_models: [],
        ia_providers: [],
        ia_provider_other: '',
        has_data_lake: null,
        has_data_governance: null,
        ia_investments: [],
        ia_infras: [],
        monetization_model: '', 
        active_clients: '', 
        has_intellectual_property: null,
        qty_patents: '', 
        qty_trademarks: '', 
        qty_software_registrations: ''
      }
    }
  },
  computed: {
    hasValidationErrors() {
      return Object.keys(this.validationErrors).length > 0
    },

    isInternational() {
      return this.selectedGeographicReachItems.some((item) => item.value === 'international')
    },

    businessModelSummary() {
      const total = this.company.business_models.length

      if (total === 0) return 'Selecione'
      if (total === 1) return '1 selecionado'

      return `${total} selecionados`
    },

    marketSegmentSummary() {
      const total = this.company.market_segments_percentage.length

      if (total === 0) return 'Selecione até 5'
      if (total === 1) return '1 selecionado'

      return `${total} selecionados`
    },

    operatingCountrySummary() {
      const total = this.company.operating_countries.length

      if (total === 0) return 'Selecione'
      if (total === 1) return '1 selecionado'

      return `${total} selecionados`
    },

    geographicReachSummary() {
      const total = this.selectedGeographicReachItems.length

      if (total === 0) return 'Selecione'
      if (total === 1) return '1 selecionado'

      return `${total} selecionados`
    },

    hasOtherBusinessModel() {
      return Boolean(this.company.business_models.find((businessModel) => businessModel.value === 'business_model_7'))
    },

    selectedOtherBusinessModel() {
      return this.company.business_models.find((businessModel) => businessModel.value === 'business_model_7') || { business_model_other: '' }
    },

    hasOtherMarketSegment() {
      return Boolean(this.company.market_segments_percentage.find((segment) => segment.value === 'other'))
    },

    selectedOtherMarketSegment() {
      return this.company.market_segments_percentage.find((segment) => segment.value === 'other') || { market_segment_other: '' }
    },

    totalPercentage() {
      return this.company.market_segments_percentage.reduce((total, segment) => {
        const percentage = this.parsePercentage(segment.percentage)

        return total + (Number.isNaN(percentage) ? 0 : percentage)
      }, 0)
    },
    totalRevenueSourcePercentage() {
      return this.company.revenue_sources_percentage.reduce((total, source) => {
        const percentage = this.parsePercentage(source.percentage)

        return total + (Number.isNaN(percentage) ? 0 : percentage)
      }, 0)
    },
    iaTypeSummary() {
    return this.newProduct.ia_types.length ? `${this.newProduct.ia_types.length} selecionados` : 'Selecione...';
    },
    iaModelSummary() {
      return this.newProduct.ia_models.length ? `${this.newProduct.ia_models.length} selecionados` : 'Selecione...';
    },
    iaProviderSummary() {
      return this.newProduct.ia_providers.length ? `${this.newProduct.ia_providers.length} selecionados` : 'Selecione...';
    },
    iaInvestmentSummary() {
      return this.newProduct.ia_investments.length ? `${this.newProduct.ia_investments.length} selecionados` : 'Selecione...';
    },
    iaInfraSummary() {
      return this.newProduct.ia_infras.length ? `${this.newProduct.ia_infras.length} selecionados` : 'Selecione...';
    }
  },

  mounted() {
    this.syncGeographicReachFieldFromItems()
    if (!this.isInternational) this.clearOperatingCountries()
    this.initTooltips()
    document.addEventListener('click', this.closeDropdownsOnOutsideClick)
  },

  updated() {
    this.initTooltips()
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdownsOnOutsideClick)
    this.destroyTooltips()
  },

  watch: {
    'company.geographic_reach'(value) {
      if (!this.isBlank(value)) this.clearValidationError('geographic_reach')

      if (value === 'international') return

      this.clearOperatingCountries()
      this.clearValidationError('international_revenue_percentage')
      this.clearValidationError('international_clients_count')
      this.clearValidationError('operating_countries')
    }
  },

  methods: {
    initTooltips() {
      this.destroyTooltips()
      if (!window.bootstrap || !window.bootstrap.Tooltip) return

      const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
      this.tooltipInstances = [...tooltipTriggerList].map((tooltipTriggerEl) => {
        return window.bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl)
      })
    },

    destroyTooltips() {
      if (!this.tooltipInstances.length) return

      this.tooltipInstances.forEach((tooltip) => tooltip.dispose())
      this.tooltipInstances = []
    },

    isBlank(value) {
      return value === null || value === undefined || String(value).trim() === ''
    },

    hasValidationError(field) {
      return Boolean(this.validationErrors[field])
    },

    clearValidationError(field) {
      this.$delete(this.validationErrors, field)
    },

    parsePercentage(value) {
      if (this.isBlank(value)) return NaN

      return Number(String(value).replace(',', '.'))
    },

    normalizeSelectedItems(items) {
      return items.reduce((selectedItems, item) => {
        const selectedItem = selectedItems.find((currentItem) => currentItem.value === item.value)

        if (selectedItem) {
          selectedItem.duplicateIds = selectedItem.duplicateIds || []
          if (item.id) selectedItem.duplicateIds.push(item.id)
          return selectedItems
        }

        selectedItems.push({
          ...item,
          duplicateIds: []
        })

        return selectedItems
      }, [])
    },

    normalizeRevenueSources(items) {
      const defaultSources = [
        { text: 'Produtos', value: 'products', percentage: null },
        { text: 'Serviços', value: 'services', percentage: null }
      ]

      return defaultSources.map((source) => {
        const selectedSource = items.find((item) => item.value === source.value)

        return selectedSource ? { ...source, ...selectedSource } : source
      })
    },

    normalizeSelectedGeographicReachItems(items) {
      return items.reduce((selectedItems, item) => {
        const value = item.value || item.geographic_reach
        if (this.isBlank(value)) return selectedItems

        const alreadySelected = selectedItems.some((selectedItem) => selectedItem.value === value)
        if (alreadySelected) return selectedItems

        const option = this.geographicReachOptions.find((currentOption) => currentOption.value === value)
        selectedItems.push({
          ...item,
          value,
          text: item.text || (option && option.text) || value
        })

        return selectedItems
      }, [])
    },

    handleMarketSegmentPercentageInput(segment) {
      if (typeof segment.percentage === 'string') {
        segment.percentage = segment.percentage.replace(',', '.')
      }

      this.clearValidationError('market_segment_percentages')
    },

    handleRevenueSourcePercentageInput(source) {
      if (typeof source.percentage === 'string') {
        source.percentage = source.percentage.replace(',', '.')
      }

      this.clearValidationError('revenue_source_percentages')
    },

    normalizeSingleMarketSegmentPercentage() {
      if (this.company.market_segments_percentage.length === 1) {
        this.company.market_segments_percentage[0].percentage = 100
        this.clearValidationError('market_segment_percentages')
      }
    },

    segmentDisplayText(segment) {
      if (segment.value === 'other' && !this.isBlank(segment.market_segment_other)) {
        return segment.market_segment_other
      }

      return segment.text
    },

    isPredominantMarketSegmentSelected() {
      return this.company.market_segments_percentage.some((segment) => {
        return segment.value === this.company.predominant_market_segment
      })
    },

    validateBusinessProfile(event) {
      if (event.submitter && event.submitter.dataset.skipProfileValidation) return

      const errors = {}

      if (this.company.business_models.length === 0) {
        errors.business_models = 'Selecione pelo menos um modelo de negócio.'
      }

      if (this.company.market_segments_percentage.length === 0) {
        errors.market_segments = 'Selecione pelo menos um segmento de mercado.'
      } else if (this.company.market_segments_percentage.length > this.maxMarketSegments) {
        errors.market_segments = `Selecione no máximo ${this.maxMarketSegments} segmentos de mercado.`
      }

      if (this.hasOtherMarketSegment && this.isBlank(this.selectedOtherMarketSegment.market_segment_other)) {
        errors.market_segment_other = 'Informe qual é o outro segmento de mercado.'
      }

      if (this.company.market_segments_percentage.length > 0) {
        const percentages = this.company.market_segments_percentage.map((segment) => this.parsePercentage(segment.percentage))
        const hasBlankPercentage = this.company.market_segments_percentage.some((segment) => this.isBlank(segment.percentage))
        const hasInvalidPercentage = percentages.some((percentage) => Number.isNaN(percentage) || percentage < 0 || percentage > 100)

        if (hasBlankPercentage) {
          errors.market_segment_percentages = 'Preencha o faturamento de todos os segmentos.'
        } else if (hasInvalidPercentage) {
          errors.market_segment_percentages = 'Informe percentuais entre 0% e 100%.'
        } else if (Math.abs(this.totalPercentage - 100) > 0.001) {
          errors.market_segment_percentages = 'A soma dos segmentos deve ser igual a 100%.'
        }

        if (this.isBlank(this.company.predominant_market_segment)) {
          errors.predominant_market_segment = 'Selecione o segmento predominante.'
        } else if (!this.isPredominantMarketSegmentSelected()) {
          errors.predominant_market_segment = 'Selecione um segmento de mercado escolhido.'
        }
      }

      const revenueSourcePercentages = this.company.revenue_sources_percentage.map((source) => this.parsePercentage(source.percentage))
      const hasBlankRevenueSourcePercentage = this.company.revenue_sources_percentage.some((source) => this.isBlank(source.percentage))
      const hasInvalidRevenueSourcePercentage = revenueSourcePercentages.some((percentage) => Number.isNaN(percentage) || percentage < 0 || percentage > 100)

      if (hasBlankRevenueSourcePercentage) {
        errors.revenue_source_percentages = 'Preencha o faturamento de produtos e serviços.'
      } else if (hasInvalidRevenueSourcePercentage) {
        errors.revenue_source_percentages = 'Informe percentuais entre 0% e 100%.'
      } else if (Math.abs(this.totalRevenueSourcePercentage - 100) > 0.001) {
        errors.revenue_source_percentages = 'A soma de produtos e serviços deve ser igual a 100%.'
      }

      if (this.selectedGeographicReachItems.length === 0) {
        errors.geographic_reach = 'Selecione o alcance geográfico.'
      }

      if (this.isInternational) {
        if (this.isBlank(this.company.international_revenue_percentage)) {
          errors.international_revenue_percentage = 'Informe a receita internacional.'
        }

        if (this.isBlank(this.company.international_clients_count)) {
          errors.international_clients_count = 'Informe a quantidade de clientes.'
        }

        if (this.company.operating_countries.length === 0) {
          errors.operating_countries = 'Selecione pelo menos um país.'
        }
      }

      this.validationErrors = errors

      if (this.hasValidationErrors) {
        event.preventDefault()
        this.enableSubmitButtons(event.target)
        this.openFirstInvalidDropdown()
        this.$nextTick(() => {
          const firstInvalid = event.target.querySelector('.is-invalid')
          if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
      }
    },

    enableSubmitButtons(form) {
      this.$nextTick(() => {
        form.querySelectorAll('[type="submit"]').forEach((button) => {
          button.disabled = false
        })
      })
    },

    openFirstInvalidDropdown() {
      if (this.hasValidationError('business_models')) {
        this.openDropdown = 'businessModel'
      } else if (this.hasValidationError('market_segments') || this.hasValidationError('market_segment_other')) {
        this.openDropdown = 'marketSegment'
      } else if (this.hasValidationError('geographic_reach')) {
        this.openDropdown = 'geographicReach'
      } else if (this.hasValidationError('operating_countries')) {
        this.openDropdown = 'operatingCountry'
      }
    },

    toggleDropdown(dropdownName) {
      this.openDropdown = this.openDropdown === dropdownName ? null : dropdownName
    },
    closeDropdownsOnOutsideClick(event) {
      if (!this.openDropdown && !this.openModalDropdown) return

      const targetElement = event.target.closest ? event.target : event.target.parentElement
      if (targetElement && targetElement.closest('.business-select-menu')) return

      this.openDropdown = null
      this.openModalDropdown = null
    },

    isGeographicReachSelected(option) {
      return this.selectedGeographicReachItems.some((item) => item.value === option.value)
    },

    toggleGeographicReach(option, event) {
      if (event.target.checked) {
        this.addGeographicReach(option)
      } else {
        this.removeGeographicReach(option)
      }
    },

    addGeographicReach(option) {
      const alreadySelected = this.selectedGeographicReachItems.some((item) => item.value === option.value)
      if (alreadySelected) return

      this.selectedGeographicReachItems.push({ ...option })
      this.syncGeographicReachFieldFromItems()
      this.clearValidationError('geographic_reach')
    },

    removeGeographicReach(option) {
      if (!option || this.isBlank(option.value)) {
        this.selectedGeographicReachItems = []
        this.syncGeographicReachFieldFromItems()
        return
      }

      const removedGeographicReach = this.selectedGeographicReachItems.find((item) => item.value === option.value)
      if (!removedGeographicReach) return

      if (removedGeographicReach.id) {
        this.removedGeographicReaches.push({ id: removedGeographicReach.id })
      }

      this.selectedGeographicReachItems = this.selectedGeographicReachItems.filter((item) => item.value !== option.value)
      this.syncGeographicReachFieldFromItems()
    },

    syncGeographicReachFieldFromItems() {
      const hierarchy = {
        local: 0,
        northeast: 1,
        national: 2,
        international: 3
      }

      const selectedValues = this.selectedGeographicReachItems
        .map((item) => item.value)
        .filter((value) => !this.isBlank(value))

      if (!selectedValues.length) {
        this.company.geographic_reach = ''
        return
      }

      this.company.geographic_reach = selectedValues.reduce((highestValue, currentValue) => {
        const highestRank = hierarchy[highestValue] ?? -1
        const currentRank = hierarchy[currentValue] ?? -1

        return currentRank > highestRank ? currentValue : highestValue
      })
    },

    isBusinessModelSelected(businessModel) {
      return this.company.business_models.some((item) => item.value === businessModel.value)
    },

    toggleBusinessModel(businessModel, event) {
      if (event.target.checked) {
        this.addBusinessModel(businessModel)
      } else {
        this.removeBusinessModel(businessModel)
      }
    },

    addBusinessModel(businessModel) {
      const alreadySelected = this.company.business_models.some((item) => item.value === businessModel.value)

      if (alreadySelected) return

      this.company.business_models.push({ ...businessModel, business_model_other: businessModel.business_model_other || '' })
      this.$delete(this.validationErrors, 'business_models')
    },

    removeBusinessModel(businessModel) {
      const removedBusinessModels = this.company.business_models.filter((item) => item.value === businessModel.value)

      removedBusinessModels.forEach((removedItem) => {
        if (removedItem.id && !this.removedBusinessModels.some((item) => item.id === removedItem.id)) {
          this.removedBusinessModels.push(removedItem)
        }

        if (removedItem.duplicateIds && removedItem.duplicateIds.length) {
          removedItem.duplicateIds.forEach((id) => {
            if (!this.removedBusinessModels.some((item) => item.id === id)) {
              this.removedBusinessModels.push({ id })
            }
          })
        }
      })

      this.company.business_models = this.company.business_models.filter((item) => item.value !== businessModel.value)
    },

    isMarketSegmentSelected(segment) {
      return this.company.market_segments_percentage.some((item) => item.value === segment.value)
    },

    isMarketSegmentDisabled(segment) {
      return !this.isMarketSegmentSelected(segment) && this.company.market_segments_percentage.length >= this.maxMarketSegments
    },

    toggleMarketSegment(segment, event) {
      if (event.target.checked) {
        this.addMarketSegment(segment)
      } else {
        this.removeMarketSegment(segment)
      }
    },

    addMarketSegment(segment) {
      const alreadySelected = this.company.market_segments_percentage.some((item) => item.value === segment.value)

      if (alreadySelected) return
      if (this.company.market_segments_percentage.length >= this.maxMarketSegments) {
        this.$set(this.validationErrors, 'market_segments', `Selecione no máximo ${this.maxMarketSegments} segmentos de mercado.`)
        return
      }

      this.company.market_segments_percentage.push({
        ...segment,
        market_segment_other: segment.market_segment_other || '',
        percentage: segment.percentage || null
      })
      this.company.market_segments = this.company.market_segments_percentage
      this.$delete(this.validationErrors, 'market_segments')
    },

    removeMarketSegment(segment, index = null) {
      const removedSegments = index === null
        ? this.company.market_segments_percentage.filter((item) => item.value === segment.value)
        : [this.company.market_segments_percentage[index]].filter(Boolean)

      removedSegments.forEach((removedSegment) => {
        if (removedSegment.id && !this.removedMarketSegments.some((item) => item.id === removedSegment.id)) {
          this.removedMarketSegments.push(removedSegment)
        }

        if (removedSegment.duplicateIds && removedSegment.duplicateIds.length) {
          removedSegment.duplicateIds.forEach((id) => {
            if (!this.removedMarketSegments.some((item) => item.id === id)) {
              this.removedMarketSegments.push({ id })
            }
          })
        }
      })

      if (index === null) {
        this.company.market_segments_percentage = this.company.market_segments_percentage.filter((item) => item.value !== segment.value)
      } else {
        this.company.market_segments_percentage.splice(index, 1)
      }

      this.company.market_segments = this.company.market_segments_percentage

      if (!this.isBlank(this.company.predominant_market_segment) && !this.isPredominantMarketSegmentSelected()) {
        this.company.predominant_market_segment = ''
      }

      if (this.company.market_segments_percentage.length <= this.maxMarketSegments) {
        this.clearValidationError('market_segments')
      }

      if (!this.hasOtherMarketSegment) {
        this.clearValidationError('market_segment_other')
      }
    },

    clearOperatingCountries() {
      this.company.operating_countries.forEach((country) => {
        const alreadyMarked = this.removedOperatingCountries.some((item) => item.id === country.id)
        if (country.id && !alreadyMarked) this.removedOperatingCountries.push(country)
      })
      this.company.operating_countries = []
    },

    isOperatingCountrySelected(country) {
      return this.company.operating_countries.some((item) => item.value === country.value)
    },

    toggleOperatingCountry(country, event) {
      if (event.target.checked) {
        this.addOperatingCountry(country)
      } else {
        this.removeOperatingCountry(country)
      }
    },

    addOperatingCountry(country) {
      const alreadySelected = this.company.operating_countries.some((item) => item.value === country.value)

      if (alreadySelected) return

      this.company.operating_countries.push({ ...country })
      this.$delete(this.validationErrors, 'operating_countries')
    },

    removeOperatingCountry(country) {
      const removedCountry = this.company.operating_countries.find((item) => item.value === country.value)

      if (removedCountry && removedCountry.id) {
        this.removedOperatingCountries.push(removedCountry)
      }

      this.company.operating_countries = this.company.operating_countries.filter((item) => item.value !== country.value)
    },
    toggleModalDropdown(menuName) {
      this.openModalDropdown = this.openModalDropdown === menuName ? null : menuName;
    },
    resetProductForm() {
      this.newProduct = {
        name: '', description: '', trl: '', uses_ia: null, ia_problem: '',
        ia_types: [], ia_models: [], ia_providers: [], ia_provider_other: '',
        has_data_lake: null, has_data_governance: null, ia_investments: [], ia_infras: [],
        monetization_model: '', active_clients: '', has_intellectual_property: null,
        qty_patents: '', qty_trademarks: '', qty_software_registrations: ''
      };
      this.openModalDropdown = null;
    }
  }
}
</script>
